export const userInfo = [
  {
    label: "계정 정보",
    field: "account_info",
    idx: 1,
    elements: [
      {
        field: "name",
        label: "*이름",
        placeholder: "이름을 입력하세요.",
        rule: "required",
      },
      {
        field: "name_eng",
        label: "*이름(영문)",
        placeholder: "영문 이름을 입력하세요. 예) Hong Gil Dong",
        rule: "required",
      },
      // {
      //   field: "member_type",
      //   label: "회원 유형",
      //   placeholder: "",
      //   readonly: true,
      // },
    ],
  },
  {
    label: "개인 정보",
    field: "personal_info",
    idx: 2,
    elements: [
      {
        field: "country",
        label: "*국가",
        placeholder: "국가를 입력하세요.",
        rule: "required",
      },
      {
        field: "phone",
        label: "*전화번호",
        placeholder: "전화번호를 입력하세요. 숫자만 입력 가능합니다. 예) 01012341234",
        rule: "required|numeric",
      },
      {
        field: "email",
        label: "*이메일",
        placeholder: "이메일을 입력하세요.",
        rule: "required|email",
      },
    ],
  },
  {
    label: "소속 정보",
    field: "organization_info",
    idx: 3,
    elements: [
      {
        field: "organization",
        label: "*소속",
        placeholder: "소속을 입력하세요.",
        rule: "required",
      },
      {
        field: "department",
        label: "부서",
        placeholder: "부서를 입력하세요.",
        // rule: "required",
      },
      {
        field: "position",
        label: "직위",
        placeholder: "직위를 입력하세요.",
        // rule: "required",
      },
    ],
  },
];

export const passwordInfo = {
  label: "신규 비밀번호",
  field: "password",
  placeholder: "새롭게 설정할 비밀번호를 입력하세요.",
  rule: "required|min:8",
};
